import { post } from "@/utils/http";
class collectionPayment {
  //代收退款
  queryCodAudits(parme){
      return post(
          '/cod/queryCodAudits',parme
      )
  }
}
export default collectionPayment